const constants = {
    defaultRowHeight: 80,
    defaultVerticalCompact: true,
    defaultPreventCollision: false,
    menuDrawerWidth: 0.3,
    focusOnCardMargin: 0.1,
};
export default constants;
